import { api, request } from './client.js';

const root = '/ai';

export const chatApi = {
  agents: () => api.get(`${root}/agents`),
  voiceConfig: () => api.get(`${root}/voice-config`),
  chat: (body) => api.post(`${root}/chat`, body),

  /**
   * Streaming chat over Server Sent Events. Fires onAgent(info) once routing
   * has picked the answering specialist, onDelta(text) for each answer chunk,
   * and resolves with the terminal `done` frame (conversationId, messageId,
   * agent, routing, toolTrace, usage).
   */
  async chatStream(body, { onAgent, onDelta, signal, headers } = {}) {
    const res = await request(`${root}/chat/stream`, { method: 'POST', body, raw: true, signal, headers });
    if (!res.ok || !res.body) {
      const err = new Error('Stream request failed');
      err.statusCode = res.status;
      throw err;
    }
    const reader = res.body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';
    let final = null;
    for (;;) {
      const { value, done } = await reader.read();
      if (done) break;
      buffer += decoder.decode(value, { stream: true });
      let idx;
      while ((idx = buffer.indexOf('\n')) >= 0) {
        const line = buffer.slice(0, idx).trim();
        buffer = buffer.slice(idx + 1);
        if (!line.startsWith('data:')) continue;
        const payload = line.slice(5).trim();
        if (payload === '[DONE]') return final;
        let evt;
        try { evt = JSON.parse(payload); } catch { continue; }
        if (evt.type === 'delta' && typeof evt.text === 'string') {
          if (typeof onDelta === 'function') onDelta(evt.text);
        } else if (evt.type === 'agent') {
          if (typeof onAgent === 'function') onAgent(evt);
        } else if (evt.type === 'done') {
          final = evt;
        } else if (evt.type === 'error') {
          const err = new Error(evt.message || 'Stream error');
          err.code = 'STREAM_ERROR';
          throw err;
        }
      }
    }
    return final;
  },

  listConversations: (params) => api.get(`${root}/conversations`, { query: params }),
  getConversation: (id) => api.get(`${root}/conversations/${id}`),
  updateConversation: (id, body) => api.patch(`${root}/conversations/${id}`, body),
  closeConversation: (id, body) => api.post(`${root}/conversations/${id}/close`, body || {}),
  deleteConversation: (id) => api.delete(`${root}/conversations/${id}`),
  // Remove a message and every later one (edit-and-resend, regenerate).
  truncate: (id, fromMessageId) => api.delete(`${root}/conversations/${id}/messages`, { body: { fromMessageId } }),
  feedback: (body) => api.post(`${root}/feedback`, body)
};
